var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecryptIconsOutlook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#34DAE2;}\n\t.st2{fill:#252A41;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#252A41;}\n\t.st4{fill:#E3E3E3;}\n\t.st5{opacity:0.1;fill:#231F20;enable-background:new    ;}\n\t.st6{fill:#D54B3D;}\n\t.st7{fill:#D72B27;}\n\t.st8{fill:url(#Path_677_1_);}\n\t.st9{fill:#005FAC;}\n\t.st10{fill:#5F01D1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    transform: "translate(13765 11823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    transform: "translate(-12440 -11112.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    className: "st9",
    d: "M-1323.78-706.37v20.1l15,2.94v-25.62L-1323.78-706.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    className: "st9",
    d: "M-1307.85-696.75v6.74h8.48c0,0,1.24-0.17,1.14-1.8l0.01-8.81l-6.21,4.2 C-1305.48-695.59-1306.98-695.74-1307.85-696.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    className: "st9",
    d: "M-1307.85-703.75h8.55c0.52-0.04,0.97,0.35,1.01,0.86c0,0.05,0,0.11,0,0.16l-7.72,5.14 l-1.83-1.17L-1307.85-703.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    className: "st0",
    d: "M-1316.24-700.9c-1.89,0-3.42,2.03-3.42,4.54s1.53,4.55,3.42,4.55s3.41-2.04,3.41-4.55 S-1314.36-700.9-1316.24-700.9z M-1316.28-693.67c-0.91,0-1.64-1.21-1.64-2.69s0.73-2.69,1.64-2.69s1.64,1.21,1.64,2.69 S-1315.37-693.68-1316.28-693.67L-1316.28-693.67z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecryptIconsOutlook);
export default __webpack_public_path__ + "static/media/recrypt_icons_outlook.fc32024d.svg";
export { ForwardRef as ReactComponent };